module.exports = __webpack_public_path__ + "img/ge.85f6bf85.png";